import { render, staticRenderFns } from "./word-list-panel.vue?vue&type=template&id=4aac1be8&"
import script from "./word-list-panel.vue?vue&type=script&lang=js&"
export * from "./word-list-panel.vue?vue&type=script&lang=js&"
import style0 from "./word-list-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aac1be8')) {
      api.createRecord('4aac1be8', component.options)
    } else {
      api.reload('4aac1be8', component.options)
    }
    module.hot.accept("./word-list-panel.vue?vue&type=template&id=4aac1be8&", function () {
      api.rerender('4aac1be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-list-panel.vue"
export default component.exports